import { Opportunity } from '../types';
import apiClient from './api-client';

// Get all opportunities
export const getOpportunities = async (): Promise<Opportunity[]> => {
  return apiClient.get<Opportunity[]>('/opportunities/');
};

// Get a single opportunity by ID
export const getOpportunityById = async (id: string): Promise<Opportunity> => {
  return apiClient.get<Opportunity>(`/opportunities/${id}/`);
};

// Interface for opportunity creation based on the backend requirements
export interface CreateOpportunityRequest {
  customer_id: string;
  title: string;
  description: string;
  status: 'Open' | 'Won' | 'Lost';
  estimated_closing_date: string;
  value: number;
  source?: string;
  products_services?: string[];
}

// Create a new opportunity
export const createOpportunity = async (data: CreateOpportunityRequest): Promise<Opportunity> => {
  return apiClient.post<Opportunity, CreateOpportunityRequest>('/opportunities/', data);
};

// Update an existing opportunity
export const updateOpportunity = async (
  id: string,
  data: Partial<CreateOpportunityRequest>
): Promise<Opportunity> => {
  return apiClient.put<Opportunity, Partial<CreateOpportunityRequest>>(
    `/opportunities/${id}/`,
    data
  );
};

// Delete an opportunity
export const deleteOpportunity = async (id: string): Promise<void> => {
  return apiClient.del<void>(`/opportunities/${id}/`);
};

// Interface for paginated admin response
export interface PaginatedOpportunityResponse {
  items: Opportunity[];
  total: number;
}

// Get admin opportunities with pagination
export const getAdminOpportunities = async (
  skip = 0,
  limit = 10
): Promise<PaginatedOpportunityResponse> => {
  return apiClient.get<PaginatedOpportunityResponse>(
    `/admin/opportunities/?skip=${skip}&limit=${limit}`
  );
};

// Interface for chat message
export interface ChatMessage {
  message: string;
  id: string;
  opportunity_id: string;
  user_id: string;
  is_admin: boolean;
  created_at: string;
}

// Interface for chat message creation
export interface CreateChatMessageRequest {
  message: string;
  opportunity_id: string;
  user_id: string;
}

// Get chat messages for an opportunity
export const getOpportunityChatMessages = async (opportunityId: string): Promise<ChatMessage[]> => {
  return apiClient.get<ChatMessage[]>(`/admin/opportunities/${opportunityId}/chat`);
};

// Send a new chat message
export const sendChatMessage = async (data: CreateChatMessageRequest): Promise<ChatMessage> => {
  return apiClient.post<ChatMessage, CreateChatMessageRequest>(
    `/admin/opportunities/${data.opportunity_id}/chat`,
    data
  );
};
